export enum SaleAndEquipmentDetailsTabs {
  Invoice = "invoice",
  Equipment = "equipment",
  Contract = "contract",
  Dealer = "dealer",
}
